import React from 'react';
import { Box, Chip, Link, Typography, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { ActiveFiltersBarProps } from './FilterBar.props';

export const ActiveFiltersBar: React.FC<ActiveFiltersBarProps> = ({
  filters,
  onRemove,
  onClearAll,
}) => {
  const theme = useTheme();

  if (filters.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1,
        px: 2.25,
        py: 1.5,
        bgcolor: theme.palette.v4.surface,
        borderTop: `1px solid ${theme.palette.v4.border}`,
      }}
    >
      <Typography
        variant="body2"
        sx={{ fontWeight: 500, mr: 0.5, color: theme.palette.text.secondary }}
      >
        Active Filters:
      </Typography>

      {filters.map((filter, index) => (
        <Chip
          key={`${filter.dataKey}-${index}`}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Box
                component="span"
                sx={{
                  bgcolor: theme.palette.v4.filterInput,
                  borderRadius: 0.5,
                  px: 0.75,
                  py: 0.25,
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  color: theme.palette.text.secondary,
                }}
              >
                {filter.field}
              </Box>
              <Typography variant="body2" component="span">
                {filter.display}
              </Typography>
            </Box>
          }
          onDelete={() => onRemove(index)}
          deleteIcon={
            <CloseIcon
              fontSize="small"
              aria-label={`Remove ${filter.field} filter`}
            />
          }
          variant="outlined"
          sx={{
            borderColor: theme.palette.v4.border,
            borderRadius: 1,
            height: 'auto',
            py: 0.5,
            '& .MuiChip-label': { px: 1 },
            '& .MuiChip-deleteIcon': {
              fontSize: '0.9rem',
              color: theme.palette.text.secondary,
              '&:hover': { color: theme.palette.error.main },
            },
          }}
        />
      ))}

      <Link
        component="button"
        variant="body2"
        onClick={onClearAll}
        sx={{
          color: theme.palette.v4.accent,
          cursor: 'pointer',
          ml: 1,
          textDecoration: 'none',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        Clear All
      </Link>
    </Box>
  );
};
